import * as React from 'react';
const Calendar = (props: React.SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		xmlSpace="preserve"
		viewBox="0 0 110.01 122.88"
		{...props}
	>
		<path
			d="M1.87 14.69h22.66l-.03-.39V4.13C24.5 1.86 26.86 0 29.76 0c2.89 0 5.26 1.87 5.26 4.13V14.3l-.03.39h38.59l-.03-.39V4.13C73.55 1.86 75.91 0 78.8 0s5.26 1.87 5.26 4.13V14.3l-.03.39h24.11c1.03 0 1.87.84 1.87 1.87v19.46c0 1.03-.84 1.87-1.87 1.87H1.87A1.889 1.889 0 0 1 0 36.01V16.55c0-1.03.84-1.86 1.87-1.86zm-1.4 27.5h109.08c.26 0 .46.21.46.46v79.76c0 .25-.21.46-.46.46H.47c-.25 0-.47-.21-.47-.46V42.66c0-.26.21-.47.47-.47zm7.76 7.78h95.07c.52 0 .94.45.94.94v64.08c0 .49-.45.94-.94.94H7.77c-.49 0-.94-.42-.94-.94V51.36c0-1.03.84-1.86 1.86-1.86l-.46.47zm70.11-20.1c2.89 0 5.26-1.87 5.26-4.13V15.11l-.03-.41H73.11l-.03.41v10.16c0 2.27 2.36 4.13 5.25 4.13l.01.47zm-49.05 0c2.89 0 5.26-1.87 5.26-4.13V15.11l-.03-.41H24.07l-.03.41v10.16c0 2.27 2.36 4.13 5.25 4.13v.47z"
			style={{
				fillRule: 'evenodd',
				clipRule: 'evenodd',
			}}
		/>
	</svg>
);
export default Calendar;
